/* eslint-disable import/newline-after-import */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-array-index-key */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import {
  Box,
  CircularProgress,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import utc from "dayjs/plugin/utc";
import useAxiosPrivate from "contexts/interceptors/axios";
dayjs.extend(utc);

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "absolute",
  backgroundColor: "#e9e9e9",
  boxShadow: "3px 2px 20px 3px rgba(0, 0, 0, 0.4)",
  borderRadius: "10px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  overflow: "auto",
  "@media (min-width: 10px)": {
    height: "90vh",
    width: "85vw",
  },
  "@media (min-width: 480px)": {
    height: "85vh",
    width: "80vw",
  },
  "@media (min-width: 640px)": {
    height: "75vh",
    width: "70vw",
  },
  "@media (min-width: 768px)": {
    height: "75vh",
    width: "70vw",
  },
  "@media (min-width: 1024px)": {
    height: "80vh",
    width: "70vw",
  },
  "@media (min-width: 1082px)": {
    height: "80vh",
    width: "65vw",
  },
  "@media (min-width: 1440px)": {
    height: "75vh",
    width: "60vw",
  },
  "@media (min-width: 2560px)": {
    height: "55vh",
    width: "50vw", // Adjust this as necessary for large screens
  },
};

export default function ViewPostModal({ open, handleClose, postId }) {
  const axiosPrivate = useAxiosPrivate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (postId && open) {
      setLoading(true);

      axiosPrivate
        .get(`/I-Abide/getPost/${postId}`)
        .then((res) => {
          setPost(res?.data);
        })
        .catch((err) => {
          setError("Error fetching post details");
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [postId, open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="view-post-modal"
      aria-describedby="view-post-details"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
            backgroundColor: "#333",
            color: "white",
          }}
        >
          <Typography variant="h6" sx={{ fontFamily: "Poppins" }}>
            Post Details
          </Typography>
          <IconButton onClick={handleClose} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ p: 3, mb: "auto" }}>
          {loading && <CircularProgress />}
          {error && <Typography color="error">{error}</Typography>}

          {post && (
            <>
              <Typography variant="h5" gutterBottom>
                {post.data.post_title}
              </Typography>

              <Typography gutterBottom sx={{ mb: 3 }}>
                Deadline:{" "}
                {dayjs(post.data.deadline).format("MMMM D, YYYY h:mm A")}
              </Typography>

              <Typography variant="h6" gutterBottom>
                Activity/Program:
              </Typography>
              <Typography sx={{ mb: 3 }}>
                {post.data.activity_Program}
              </Typography>

              <Typography variant="h6" gutterBottom>
                Title of Memo:
              </Typography>
              <Typography sx={{ mb: 3 }}>{post.data.title_of_memo}</Typography>

              <Typography variant="h6" gutterBottom>
                Link:
              </Typography>
              <Typography sx={{ mb: 3 }}>
                {post.data.link_to_memo ? (
                  <a
                    href={post.data.link_to_memo}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {post.data.link_to_memo}
                  </a>
                ) : (
                  "No link available"
                )}
              </Typography>

              <Typography variant="h6" gutterBottom>
                Instructions:
              </Typography>
              <Typography sx={{ mb: 3 }}>{post.data.instructions}</Typography>

              <Typography variant="h6" gutterBottom>
                Shared To:
              </Typography>
              <Typography sx={{ mb: 3 }}>
                {post.data.shareTo && post.data.shareTo.length > 0
                  ? post.data.shareTo.map((recipient, index) => (
                      <span key={index}>
                        {recipient.recipient_name}
                        {index < post.data.shareTo.length - 1 ? "<br />" : ""}
                      </span>
                    ))
                  : "Default Recipients"}
              </Typography>
              <Typography variant="h6" gutterBottom>
                Link for Submission:
              </Typography>
              <Typography sx={{ mb: 3 }}>
                {post.data.linkProvided ? (
                  <a
                    href={post.data.linkProvided}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {post.data.linkProvided}
                  </a>
                ) : (
                  "No link available"
                )}
              </Typography>

              <Box sx={{ mt: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  Created At:{" "}
                  {dayjs(post.createdAt).format("MMMM D, YYYY h:mm A")}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Deadline: {dayjs(post.deadline).format("MMMM D, YYYY h:mm A")}
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ display: "flex" }}
                >
                  Posted By: {post.data.posted_by},{" "}
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontStyle: "italic" }}
                  >
                    {post.data.role}
                  </Typography>
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </Box>
    </Modal>
  );
}
